import { render } from "./attestation.vue?vue&type=template&id=7157dc7e&scoped=true"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"

import "./attestation.vue?vue&type=style&index=0&id=7157dc7e&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7157dc7e"]])

export default __exports__